import styled from 'styled-components';

interface ThProps {
  $sortable?: boolean;
}

export const Th = styled.th<ThProps>`
  color: #696969;
  background-color: #f5f5f5;
  text-align: start;
  border: 0;
  font-size: 0.7rem;
  font-weight: 400;
  padding: 0 1.2rem;
  height: 2.2rem;
  cursor: ${({ $sortable }) => ($sortable ? 'pointer' : 'default')};
  transition: background 0.2s;
  &:hover {
    background: ${({ $sortable }) => ($sortable ? '#f1f3f5' : '#f5f5f5')};
  }
`;

export const ConfigMenuWrapper = styled.div`
  position: absolute;
  top: -45px;
  right: 1rem;
  z-index: 10;
`;

export const ConfigMenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  &:hover {
    background: #f0f0f0;
  }
`;

export const ColumnMenu = styled.div`
  position: absolute;
  top: 40px;
  right: 0;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  padding: 12px;
  min-width: 200px;
  z-index: 20;
`;

export const ColumnMenuTitle = styled.strong`
  font-size: 14px;
  display: block;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
`;

export const ColumnMenuList = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ColumnMenuItem = styled.div`
  display: flex;
  align-items: center;
  
  label {
    margin-left: 8px;
    font-size: 14px;
    cursor: pointer;
    flex-grow: 1;
  }

  input[type="checkbox"] {
    cursor: pointer;
  }
`;

export const ThContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const TableContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow: auto;
`;

export const OptionsImage = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

export const StyledSelect = styled.select`
  padding: 6px 10px;
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 8px;
  color: #333;
  font-family: 'Inter', sans-serif;
  outline: none;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  cursor: pointer;
  width: 100%;

  &:hover {
    border-color: #999;
  }

  &:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`; 